import { NonEmptyArray, EDecorationType } from '../../../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDecorationsListFilter } from 'shared/selectors/advancedFilters';

export const DecorationsListContainer: FC = () => {
  const { value, options } = useSelector(selectDecorationsListFilter);

  const onChange = useFilterChangeCallback();

  const handleDecorationsChange = useCallback(
    (decorationsList: NonEmptyArray<EDecorationType> | null) => {
      onChange({ action: 'setDecorationsList', arguments: [decorationsList] });
    },
    [onChange],
  );

  return <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleDecorationsChange} />;
};
